import axios from "axios"

const API = axios.create({ baseURL: '/api/subscribers' })

//Subscriber Crud
export const createSubscriber = (newSubscriber) => API.post('/', newSubscriber)
export const readSubscribers = () => API.get('/')
export const updateSubscriber = (id, updatedSubscriber) => API.patch(`/${id}`, updatedSubscriber)
export const deleteSubscriber = (id) => API.delete(`/${id}`)